import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, toHandlers as _toHandlers, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "edit-form-wrapper"
};
const _hoisted_2 = {
  class: "form-wrapper"
};
const _hoisted_3 = {
  class: "form-foot-wrapper"
};
const _hoisted_4 = {
  key: 0,
  class: "status-error"
};
import { computed, watch, ref, reactive, onMounted } from 'vue';
import { useComponentModalInstance, modal } from '@/share/components';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
import { toRaw, unref } from 'vue';
export default {
  __name: 'mg-editor-form',
  props: {
    id: {
      type: [Number, String],
      default: ''
    },
    queryApi: {
      type: String,
      default: ''
    },
    saveApi: {
      type: String,
      default: ''
    },
    queryParams: {
      type: [Object, Function],
      default: undefined
    },
    afterQuery: {
      type: [Function],
      default: undefined
    },
    beforeSave: {
      type: [Function],
      default: undefined
    },
    afterSave: {
      type: [Function],
      default: undefined
    },
    items: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    },
    formOptions: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'reset', 'update:data', 'success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const formRef = ref();
    const compModalInstance = useComponentModalInstance();
    const emit = __emit;
    const props = __props;
    const formData = reactive({});
    const {
      loading: queryLoading,
      error: queryError,
      runAsync: queryDetailAsync
    } = fetchApi({
      getName() {
        return props.queryApi;
      }
    });
    const {
      loading: saveLoading,
      error: saveError,
      runAsync: saveAsync
    } = fetchApi({
      getName() {
        return props.saveApi;
      }
    });
    const clearData = () => {
      Object.keys(props.data || {}).forEach(k => {
        delete formData[k];
      });
    };
    watch(() => formData, val => {
      emit('update:data', toRaw(unref(val)));
    }, {
      deep: true
    });
    watch(() => props.data, val => {
      Object.assign(formData, toRaw(unref(val || {})));
    }, {
      immediate: true,
      deep: true
    });

    // 获取数据详情
    const getDetail = async id => {
      queryError.value = '';
      const {
        queryApi,
        queryParams,
        afterQuery
      } = props;
      if (!queryApi || queryLoading.value) return Promise.resolve(false);
      const postParams = {
        id
      };
      if (queryParams && typeof queryParams === 'function') {
        const tmp = await queryParams({
          id
        });
        Object.assign(postParams, tmp);
      } else if (queryParams && typeof queryParams === 'object') {
        Object.assign(postParams, queryParams);
      }
      const {
        error,
        ...content
      } = await queryDetailAsync(postParams);
      if (error) {
        queryError.value = error;
        return Promise.resolve(false);
      }
      let resultData = content;
      if (typeof afterQuery === 'function') {
        resultData = await afterQuery({
          params: postParams,
          data: content
        });
      }
      Object.assign(formData, resultData);
      return Promise.resolve(resultData);
    };
    const saveForm = async () => {
      saveError.value = '';
      const {
        saveApi,
        beforeSave,
        afterSave
      } = props;
      if (!saveApi || saveLoading.value) {
        modal.notification.info('未配置数据存储接口或数据正在保存中');
        return Promise.resolve(false);
      }
      let postData = {
        ...formData,
        id: props.id || ''
      };
      if (typeof beforeSave === 'function') {
        const tmp = await beforeSave(postData);
        if (!tmp) return Promise.resolve(false);
        postData = tmp;
      }
      const {
        error,
        ...res
      } = await saveAsync(postData);
      if (error) {
        saveError.value = error;
        return Promise.resolve(false);
      }
      if (typeof afterSave === 'function') {
        const ret = await afterSave({
          data: postData,
          result: res
        });
        return Promise.resolve(ret);
      }
      return Promise.resolve(res);
    };
    const formFooterItems = [{
      align: 'center',
      span: 24,
      itemRender: {
        name: 'VxeButtonGroup',
        options: [{
          type: 'submit',
          content: '提交',
          status: 'primary'
        }, {
          type: 'reset',
          content: '重置'
        }]
      }
    }];
    const formItems = computed(() => {
      const items = props.items.filter(t => t.visible || typeof t.visible === 'undefined');
      if (!isModal || !props.showFooter) return items;
      return [...items, ...formFooterItems];
    });
    const isModal = computed(() => compModalInstance.isModal());
    const formOptions = reactive({
      titleColon: true,
      titleAlign: 'right',
      titleWidth: 120,
      'prevent-submit': false,
      // 禁用表单自动提交功能
      validConfig: {
        autoPos: true,
        theme: 'simple' // simple||bright
      }
    });
    watch(() => props.formOptions, val => {
      Object.assign(formOptions, toRaw(unref(val)));
    }, {
      deep: true,
      immediate: true
    });
    const validate = async () => {
      saveError.value = '';
      const errors = await formRef.value.validate();
      if (errors) {
        saveError.value = '输入数据未通过校验规则，请检查';
        return Promise.resolve(false);
      }
      return Promise.resolve(true);
    };
    const getDetailById = async id => {
      if (!id) return Promise.resolve(false);
      return getDetail(id);
    };
    const postData = async () => {
      const valid = await validate();
      if (!valid) return Promise.resolve(false);
      const res = await saveForm();
      if (!res) {
        emit('success', false, {
          saveError: saveError.value,
          queryError: queryError.value
        });
        return Promise.resolve(false);
      }
      modal.notification.success('保存数据成功');
      emit('success', res, {
        saveError: '',
        queryError: ''
      });
      return Promise.resolve(res);
    };
    const reset = () => {
      !!formRef.value && formRef.value.reset();
      emit('reset');
    };
    const submit = async () => {
      emit('submit', {
        ...props.data
      });
      return postData();
    };
    const formEvents = {
      submit() {
        return postData();
      },
      reset() {
        reset();
      }
    };
    watch(() => props.id, val => {
      if (!val) {
        clearData();
        return;
      }
      getDetailById(val);
    }, {
      immediate: true
    });
    __expose({
      validate,
      reset,
      submit,
      getDetail,
      getDetailById,
      saveForm
    });
    onMounted(() => {
      if (compModalInstance.isModal()) {
        compModalInstance.setConfirmListener(async () => {
          return submit();
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_form = _resolveComponent("vxe-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_vxe_form, _mergeProps({
        ref_key: "formRef",
        ref: formRef
      }, formOptions, {
        items: formItems.value,
        data: formData,
        rules: __props.rules,
        loading: __props.loading || _unref(queryLoading) || _unref(saveLoading)
      }, _toHandlers(formEvents)), _createSlots({
        _: 2
      }, [_renderList(Object.keys(_ctx.$slots), key => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope))])
        };
      })]), 1040, ["items", "data", "rules", "loading"])]), _createElementVNode("div", _hoisted_3, [!!_unref(queryError) || !!_unref(saveError) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("i", {
        class: "vxe-icon-warning-triangle"
      }, null, -1)), _createElementVNode("span", null, _toDisplayString(_unref(queryError)) + " " + _toDisplayString(_unref(saveError)), 1)])) : _createCommentVNode("", true)])]);
    };
  }
};